export const DAY_OF_WEEK_FORMAT = 'dddd, ';
